import { StatusEnum } from "@project-management-system/shared-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('sample_po_order') 
export class SamplePoOrderEntity {
    @PrimaryGeneratedColumn('increment', {
        name: 'excel_id',
    })
    excelId: number

    @Column("varchar",{
        name:'buyer_code',
        nullable:false,
        
    })
    buyerCode: string

    @Column("varchar",{
        name:'buyer_po',
        nullable:false,
        
    })
    buyerPo: string

    @Column("varchar",{
        name:'buyer_style',
        nullable:false,
        
    })
    buyerStyle: string

    @Column("varchar",{
        name:'buyer_address',
        nullable:false,
        
    })
    buyerAddress: string

    @Column("varchar",{
        name:'earliest_ex_fty',
        nullable:false,
        
    })
    earliestExFty: string

    @Column("varchar",{
        name:'delivery_date',
        nullable:false,
        
    })
    deliveryDate: string

    @Column("varchar",{
        name:'delivery_address',
        nullable:false,
        
    })
    deliveryAddress: string

    @Column("varchar",{
        name:'item_description',
        nullable:false,
        
    })
    itemDescription: string

    @Column("varchar",{
        name:'order_qty',
        nullable:false,
        
    })
    orderQty: string

    @Column("varchar",{
        name:'sales_price',
        nullable:false,
        
    })
    salesPrice: string

    @Column("varchar",{
        name:'currency',
        nullable:false,
        
    })
    currency: string

    @Column("varchar",{
        name:'sample_item_no',
        nullable:false,
        
    })
    sampleItemNo: string

    @Column("varchar",{
        name:'discount_item',
        nullable:false,
        
    })
    discountItem: string



    @Column({
        nullable: false,
        name: "is_active",
        default:1
    })
    isActive: boolean;

    @Column('varchar', {
        nullable: true,
        length: 20,
        name: 'created_user'
    })
    createdUser: string | null;

    @Column('varchar', {
        nullable: true,
        length: 20,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: string;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: string;

    @VersionColumn({
        default: 1,
        name: "version_flag",
    })
    versionFlag: number;

    @Column("enum", {
        enum: StatusEnum,
        name: 'status',
        default: StatusEnum.OPEN
    })
    status: StatusEnum;

    
}